export default "__VITE_ASSET__DXuIp1YI__"